// extracted by mini-css-extract-plugin
export default {"searchArea":"ProcessTree_searchArea__nWOjb","filter_text":"ProcessTree_filter_text__g2BAy","treeArea":"ProcessTree_treeArea__xenN0","treeBox":"ProcessTree_treeBox__kz1pU"};